import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpModule } from '@angular/http';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { StoreModule, provideStore } from '@ngrx/store/index';
import {EffectsModule} from '@ngrx/effects/index';

import { DragulaModule, DragulaService, dragula } from 'ng2-dragula/index';

import { LibComponent } from './component/lib.component';
import { LibService } from './service/lib.service';
import { CollapsibleComponent } from './collapsible/collapsible.component';
import { ConfigService } from './config/config.service';
import { ProductsService } from './products/products.service';
import { ProductImageService } from './products/product-image.service';
import { ProductImageListComponent } from './product-image-list/product-image-list.component';
import { CartService } from './cart/cart.service';
import { CartComponent } from './cart/cart.component';
import { AddCartComponent } from './cart/cart-button.component';
import { SalesTaxService } from './sales-tax/sales-tax.service';
import { CheckoutService } from './checkout/checkout.service';
import { CheckoutComponent } from './checkout/checkout.component';
import { ProductCategoriesService } from './product-categories/product-categories.service';
import { ProductCategoriesEditorComponent } from './product-categories/product-categories-editor.component';
import { ProductProductCategoriesService } from './product-categories/product-product-categories.service';
import { ProductProductCategoriesEditorComponent } from './product-categories/product-product-categories-editor.component';
import { ContextService } from './context/context.service';
import { ProductDetailsComponent } from './product-details/product-details.component';
import { ProductAdminComponent } from './product-admin/product-admin.component';
import { ProductAdminDetailsComponent } from './product-admin-details/product-admin-details.component';
import { StatesService } from './states/states.service';
import { OrderSummaryComponent } from './order-summary/order-summary.component';

import { reducer } from './store/store.reducer';
import { ProductCategoriesEffects } from './product-categories/product-categories.effects';
import { ProductCategoriesActions } from './product-categories/product-categories.actions';
import { OrderConfirmationComponent } from './order-confirmation/order-confirmation.component';
import { OrderConfirmationService } from './order-confirmation/order-confirmation.service';

import { ProductCategoriesBrowserComponent } from './product-categories/product-categories-browser.component';

import { LoggingService } from './loging/logging.service';

import { SellerConnectComponent } from './seller-connect/seller-connect.component';
import { SellerConnectService } from './seller-connect/seller-connect.service';
export class LibModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [
    LibComponent,
    CollapsibleComponent,
    ProductImageListComponent,
    CartComponent,
    AddCartComponent,
    CheckoutComponent,
    ProductCategoriesEditorComponent,
    ProductProductCategoriesEditorComponent,
    ProductDetailsComponent,
    ProductAdminComponent,
    OrderSummaryComponent,
    ProductAdminDetailsComponent,
    OrderConfirmationComponent,
    ProductCategoriesBrowserComponent,
    SellerConnectComponent],
  providers: [
    LibService,
    ConfigService,
    ProductsService,
    ProductImageService,
    CartService,
    SalesTaxService,
    CheckoutService,
    ProductCategoriesService,
    ProductProductCategoriesService,
    ContextService,
    StatesService,
    DragulaService,
    ProductCategoriesActions,
    OrderConfirmationService,
    LoggingService,
    SellerConnectService],
  exports: [
    LibComponent,
    CollapsibleComponent,
    ProductImageListComponent,
    CartComponent,
    AddCartComponent,
    CheckoutComponent,
    ProductCategoriesEditorComponent,
    ProductProductCategoriesEditorComponent,
    ProductDetailsComponent,
    ProductAdminComponent,
    OrderSummaryComponent,
    ProductAdminDetailsComponent,
    OrderConfirmationComponent,
    ProductCategoriesBrowserComponent,
    SellerConnectComponent],
  imports: [
    CommonModule,
    HttpModule,
    RouterModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    DragulaModule,

    /**
     * StoreModule.provideStore is imported once in the root module, accepting a reducer
     * function or object map of reducer functions. If passed an object of
     * reducers, combineReducers will be run creating your application
     * meta-reducer. This returns all providers for an @ngrx/store
     * based application.
     */
    StoreModule.provideStore(reducer),
    EffectsModule.run(ProductCategoriesEffects)
  ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function LibModule_tsickle_Closure_declarations() {
/** @type {?} */
LibModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
LibModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
